import React from 'react';
import "./font.css"

const Articles = () => {
	return (
		<div class="styled-font">
			<h1>We will write aricles here!</h1>
		</div>
	);
};

export default Articles;